import React, { createContext, useContext } from 'react';

import { TreeNode } from 'types/interfaces/TreeNode';

interface DepartmentContextValue {
  showAllDepartments: boolean;
  toggleShowAllDepartments: () => void;
  departments: TreeNode[];
  loadTasks: () => void;
  selectedDepartments: Record<number, TreeNode | null>;
  setSelectedDepartments: React.Dispatch<React.SetStateAction<Record<number, TreeNode | null>>>; // Добавить
}

const DepartmentContext = createContext<DepartmentContextValue | undefined>(undefined);

export const DepartmentProvider: React.FC<{
  value: DepartmentContextValue;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return (
    <DepartmentContext.Provider value={value}>
      {children}
    </DepartmentContext.Provider>
  );
};

export const useDepartmentContext = () => {
  const context = useContext(DepartmentContext);
  if (!context) {
    throw new Error('useDepartmentContext must be used within DepartmentProvider');
  }
  return context;
};
